import api from './api';

export const facturasService = {

  listar: () =>
    api.get('/facturas'),

  obtener: (id) =>
    api.get(`/facturas/${id}`),

  crear: (fecha, numFactura) => {
    const body = {};
    if (fecha) body.fecha = fecha;
    if (numFactura) body.numFactura = String(numFactura);
    return api.post('/facturas', body);
  },

  eliminar: (id) =>
    api.delete(`/facturas/${id}`),

  añadirSiniestro: (idFactura, idSiniestro) =>
    api.post(`/facturas/${idFactura}/lineas`, { idSiniestro }),

  eliminarLinea: (idLinea) =>
    api.delete(`/facturas/lineas/${idLinea}`),

  cobrar: (idFactura) =>
    api.post(`/facturas/${idFactura}/cobrar`),

  actualizarNumFactura: (idFactura, numFactura) =>
    api.patch(`/facturas/${idFactura}/num-factura`, { numFactura }),
};
